import { AvailableIndexes as BeforeInflationIndexes } from './before_inflation/index';
import { AvailableIndexes as AfterInflationIndexes } from './after_inflation/index';

const AvailableIndexes = {
    before: BeforeInflationIndexes,
    after: AfterInflationIndexes,
};

export function getIndexes(inflation='before') {
    return AvailableIndexes[inflation];
}

export const indexGroupOrder = {
    'Fama/French US Indexes (1927)': 1,
    'Fama/French US Indexes (1964)': 2,
    'Fama/French US Bonds (1926)': 2.5,
    'Fama/French International Indexes (1975)': 3,
    'Fama/French Asia Pacific Indexes (1975)': 4,
    'Fama/French Australia Indexes (1975)': 5,
    'Fama/French Europe and Scandinavia Indexes (1975)': 7,
    'Fama/French Japan Indexes (1975)': 8,
    'Fama/French UK Indexes (1975)': 9,
    'Fama/French Canada Indexes (1977)': 11,
    'Fama/French EM Indexes (1990)': 12,
}

/* 
    Jeff's preferred grouping and order in dropdown
    ---
    
    Fama/French US Indexes (1927)
        Total US Market
        US Growth
        US Value
        US Large Cap
        US Large Growth
        US Large Neutral
        US Large Value
        US Small Cap
        US Small Growth
        US Small Neutral
        US Small Value

    Fama/French US Indexes (1964)
        US High Profitability
        US Low Profitability

    Fama/French International Indexes (1975)
        International Growth
        International Market
        International Value

    Fama/French Asia Pacific Indexes (1975)
        Asia Pacific Growth
        Asia Pacific Market
        Asia Pacific Value

    Fama/French Australia Indexes (1975)
        Australia Growth
        Australia Market
        Australia Value Index

    Fama/French Australia Indexes (1975)
        Australia Growth (AUD)
        Australia Market (AUD)
        Australia Value (AUD)

    Fama/French Europe and Scandinavia Indexes (1975)
        Europe and Scandinavia Growth
        Europe and Scandinavia Market
        Europe and Scandinavia Value

    Fama/French Europe and Scandinavia Indexes (1975)
        Europe and Scandinavia Growth (EUR)
        Europe and Scandinavia Value (EUR)

    Fama/French Japan Indexes (1975)
        Japan Growth
        Japan Market
        Japan Value
2
    Fama/French UK Indexes (1975)
        UK Growth
        UK Market
        UK Value

    Fama/French UK Indexes (1975)
        UK Growth (GBP)
        UK Value (GBP)

    Fama/French Canada Indexes (1977)
        Canada Growth
        Canada Market
        Canada Value

    Fama/French EM Indexes (1990)
        Emerging Markets Growth
        Emerging Markets
        Emerging Markets Small Cap
        Emerging Markets Value

    Note that this adds up to 45 indexes. 
    Let’s leave off the FF Int’l Growth and Value indexes in (CAD) for now.
*/